import useHasMounted from '@/hooks/useHasMounted'
import classNames from 'classnames'
import Overlay from './overlay'

import type { MobileOverlayStateType } from './utils/types'

export default function Slider({
  overlay,
  onOverlayClick = () => {},
  children,
  showOverlay = false,
  isAuthenticated,
}: {
  overlay: MobileOverlayStateType
  onOverlayClick?: React.MouseEventHandler
  children: React.ReactNode
  showOverlay?: boolean
  isAuthenticated: boolean
}) {
  const hasMounted = useHasMounted()

  if (!hasMounted) {
    return null
  }

  let widthClass = ''

  if (overlay) {
    if (
      overlay !== 'logged-in-sidebar-overlay' &&
      typeof overlay !== 'object'
    ) {
      widthClass = 'w-full'
    }

    if (
      (overlay === 'nav-overlay' || typeof overlay === 'object') &&
      !isAuthenticated
    ) {
      widthClass = 'w-full md:w-96'
    }

    if (
      (overlay === 'logged-in-sidebar-overlay' ||
        typeof overlay === 'object') &&
      isAuthenticated
    ) {
      widthClass = 'w-full md:w-96'
    }
  } else {
    widthClass = 'w-0'
  }

  return (
    <Overlay>
      {showOverlay && (
        <div
          className="bg-brand-black fixed left-0 top-0 z-40 h-screen w-screen opacity-60"
          onClick={onOverlayClick}
        />
      )}

      <div
        className={classNames(
          'transition-width duration-200 ease-in-out',
          'h-full',
          'fixed right-0 top-0',
          'bg-brand-grey-background',
          'z-50',
          'overflow-y-auto',
          widthClass,
          {
            'mt-[79px]': overlay === 'nav-overlay',
          },
        )}
      >
        <div>{children}</div>
      </div>
    </Overlay>
  )
}
